var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0241 11.6316C23.9354 5.17423 18.6317 0.0114705 12.1743 0.0949934C5.71695 0.178516 0.554195 5.48744 0.637718 11.9448C0.726461 18.4022 6.03017 23.5649 12.4875 23.4814C18.9449 23.3927 24.1129 18.089 24.0241 11.6316ZM12.3309 4.26592C13.2549 4.26592 14.0014 5.0124 14.0014 5.93638C14.0014 6.86035 13.2549 7.60683 12.3309 7.60683C11.407 7.60683 10.6605 6.86035 10.6605 5.93638C10.6605 5.0124 11.407 4.26592 12.3309 4.26592ZM14.6278 19.0442H10.034V18.47H11.1825V10.1177H10.034V9.49132H13.4794V18.47H14.6278V19.0442Z",
    fill: "#9D9CB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.780bfe44a89657f0e200e2b48abaf54b.svg";
export { ForwardRef as ReactComponent };